import localSave from '@utils/local-save'
import { AUTH_ROUTES } from '@utils/auth-routes'

const KEY = 'postAuthRedirect'

// Session-scoped on purpose: the banner -> auth -> plans hand-off always happens
// inside one tab session. Persisting it let an abandoned banner click survive
// indefinitely and hijack a later, unrelated sign-in.
const STORAGE = 'sessionStorage'

export default {
    // Remember where to send the user once they finish signing in / signing up.
    set(path) {
        localSave.save(KEY, path, STORAGE)
    },

    // Return the remembered destination (or null) and clear it, so it is
    // honored exactly once.
    consume() {
        const target = localSave.get(KEY, STORAGE)
        if (target) localSave.delete(KEY, STORAGE)
        return target || null
    },

    // Forget the remembered destination without navigating anywhere.
    clear() {
        localSave.delete(KEY, STORAGE)
    },

    // The destination only means something while the user is inside the auth
    // flow. Once they navigate out of it without authenticating it is stale, so
    // drop it before it can hijack an unrelated later sign-in.
    // Gated on `routeFrom` so the initial navigation after an OAuth round-trip
    // (routeFrom.name === null) leaves the destination intact for
    // AppInitializer.checkAuthentication() to consume.
    clearOnAuthFlowExit(routeFrom, routeTo) {
        const wasInAuthFlow = AUTH_ROUTES.includes(routeFrom && routeFrom.name)
        const staysInAuthFlow = AUTH_ROUTES.includes(routeTo && routeTo.name)
        if (wasInAuthFlow && !staysInAuthFlow) this.clear()
    },

    // Thin wrapper around navigation so callers never touch window.location
    // directly — keeps login/signup/banner unit-testable.
    _navigate(url) {
        window.location.replace(url)
    },

    // Send the user to the remembered destination if there is one, otherwise
    // to `fallback`. Consumes the destination.
    resolveAfterAuth(fallback) {
        this._navigate(this.consume() || fallback)
    },
}
